import { createFileRoute } from '@tanstack/react-router';
import { McpClientDetailRoute } from '@/pages/mcp-clients/detail-route';

/** Deep link al dettaglio: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute('/admin/_layout/mcp-clients/_layout/$id')({
  component: McpClientDetailRouteComponent,
});

function McpClientDetailRouteComponent() {
  const { id } = Route.useParams();

  return <McpClientDetailRoute clientId={id} />;
}
